module.exports = __webpack_public_path__ + "img/01_Boton_Seguridad.4caa41f1.png";